/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Pricing_Toggle_DiscountInputs */

const tr_pricing_toggle_discount = /** @type {(inputs: Pricing_Toggle_DiscountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`%${i?.percent} İNDİRİM`)
};

const en_pricing_toggle_discount = /** @type {(inputs: Pricing_Toggle_DiscountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% DISCOUNT`)
};

const de_pricing_toggle_discount = /** @type {(inputs: Pricing_Toggle_DiscountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% RABATT`)
};

const ru_pricing_toggle_discount = /** @type {(inputs: Pricing_Toggle_DiscountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`СКИДКА ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "{percent}% DISCOUNT" |
*
* @param {Pricing_Toggle_DiscountInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_toggle_discount = /** @type {((inputs: Pricing_Toggle_DiscountInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Toggle_DiscountInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_toggle_discount(inputs)
	if (locale === "de") return de_pricing_toggle_discount(inputs)
	if (locale === "ru") return ru_pricing_toggle_discount(inputs)
	return tr_pricing_toggle_discount(inputs)
});